import Vue from 'vue';
import Vuex from 'vuex';

import base from './domains/base/store';
import account from './domains/account/store';
import orders from './domains/admin/orders/store';
import products from './domains/admin/products/store';
import printers from './domains/admin/printers/store';
import ruleBuilder from './domains/admin/rule-builder/store';
import printerJobs from './domains/admin/printer-jobs/store';
import customers from './domains/admin/customers/store';
import invoices from './domains/admin/invoices/store';

Vue.use(Vuex);

const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    ...base,
    modules: {
        account,
        orders,
        products,
        printers,
        ruleBuilder,
        printerJobs,
        customers,
        invoices,
    },
});

if (module.hot) {
    module.hot.accept(
        [
            './domains/base/store',
            './domains/account/store',
            './domains/admin/orders/store',
            './domains/admin/products/store',
            './domains/admin/printers/store',
            './domains/admin/rule-builder/store',
            './domains/admin/printer-jobs/store',
            './domains/admin/customers/store',
            './domains/admin/invoices/store',
        ],
        () => {
            store.hotUpdate({
                ...require('./domains/base/store').default,
                modules: {
                    account: require('./domains/account/store').default,
                    orders: require('./domains/admin/orders/store').default,
                    products: require('./domains/admin/products/store').default,
                    printers: require('./domains/admin/printers/store').default,
                    ruleBuilder: require('./domains/admin/rule-builder/store').default,
                    printerJobs: require('./domains/admin/printer-jobs/store').default,
                    customers: require('./domains/admin/customers/store').default,
                    invoices: require('./domains/admin/invoices/store').default,
                },
            });
        },
    );
}

export default store;
